import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';
import clsx from 'classnames';
import { useStyles } from '../../hooks';

const styles = theme => ({
  fullScreen: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.tooltip + 1,
    backgroundColor: theme.palette.action.disabled
  }
});

const LoadingIndicator = ({
  height = '100vh',
  fullScreen = false,
  ...otherProps
}) => {
  const classes = useStyles(styles);

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center" 
      height={height}
      className={clsx({ [classes.fullScreen]: fullScreen })}
      {...otherProps}
    >
      <CircularProgress size={50} disableShrink/>
    </Box>
  );
}

LoadingIndicator.propTypes = {
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  fullScreen: PropTypes.bool,
}

export default LoadingIndicator;
